/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface StatisticsInDateRangeDto { 
    date?: string;
    amount?: number;
    discardAmount?: number;
    transferAmount?: number;
}

